// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: 'AIzaSyBG89zUYZE0fhGmzlxpT_x60DfrmiFm2cs',
    authDomain: 'zastitatrade.firebaseapp.com',
    databaseURL: 'https://zastitatrade.firebaseio.com',
    projectId: 'zastitatrade',
    storageBucket: 'zastitatrade.appspot.com',
    messagingSenderId: '717857926761',
    appId: '1:717857926761:web:53bb08e90e52a75d'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
